<template>
  <div>
    <div class="subtitle center no_mobile">הזן פרטי מטופל</div>
    <h2 class="subtitle_inner mobile_only">הזן פרטי מטופל:</h2>
    <input type="hidden" name="passport" v-model="surg.id_num" />

    <div
      class="inner_group bg--white desk_inner_width desk-flex desk-flex--top desk-flex--start split-4 desk-no-pad"
    >
      <div
        v-for="field in filteredFields"
        :key="field.name"
        class="add_new_row flex"
        :class="field.customClass"
      >
        <div class="add_new_row_col1">{{ field.label }}</div>
        <div class="add_new_row_col2">
          <validation-provider
            :name="field.name"
            :rules="field.rules"
            v-slot="{ errors }"
          >
            <div class="input-opacity" :class="{ disabled: field.disabled }">
              <input
                v-if="field.name === 'birth_date'"
                :type="field.inputType"
                :name="field.name"
                v-model="surg[field.name]"
                :autocomplete="field.autocomplete"
                :placeholder="field.placeholder"
                v-mask="['##/##/####']"
              />
              <input
                v-else-if="field.type === 'input'"
                :type="field.inputType"
                :name="field.name"
                v-model="surg[field.name]"
                :autocomplete="field.autocomplete"
                :placeholder="field.placeholder"
              />
              <select2
                v-else
                :name="field.name"
                dir="rtl"
                v-model="surg[field.name]"
              >
                <option
                  v-for="(option, index) in field.options"
                  :key="index"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select2>
            </div>
            <span class="error-message">{{ errors[0] }}</span>
            <span class="note" v-if="field.note">{{ field.note }}</span>
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parentalStatus } from "../../../../utilities/surgery-questions";
import { setTutorial } from "@/utilities/intro.js";

export default {
  name: "PatientDetails",
  props: {
    surg: { required: true }
  },
  computed: {
    isPatientUnder18() {
      if (!this.surg.birth_date) return false;

      const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
      if (!datePattern.test(this.surg.birth_date)) return false;

      const birthDate = this.$moment(this.surg.birth_date, "DD/MM/YYYY", true);
      if (!birthDate.isValid()) return false;

      if (birthDate.isSameOrAfter(this.$moment())) return false;

      const age = this.$moment().diff(birthDate, "years");
      return age < 18;
    },
    filteredFields() {
      if (this.isPatientUnder18) {
        this.intro();
        return this.fields;
      }
      return this.fields.filter(field => field.name !== "parental_status");
      // return this.fields.map(field => {
      //   if (field.name === "parental_status") {
      //     return {
      //       ...field,
      //       rules: this.isPatientUnder18 ? "required" : "",
      //       disabled: !this.isPatientUnder18
      //     };
      //   }
      //   return field;
      // });
    }
  },
  data() {
    return {
      fields: [
        {
          label: "שם משפחה*",
          name: "last_name",
          type: "input",
          inputType: "text",
          rules: "required",
          autocomplete: "off"
        },
        {
          label: "שם פרטי*",
          name: "first_name",
          type: "input",
          inputType: "text",
          rules: "required",
          autocomplete: "off"
        },
        {
          label: "תאריך לידה*",
          name: "birth_date",
          type: "input",
          inputType: "text",
          rules: "required|birth_date",
          autocomplete: "off",
          placeholder: "dd/mm/yyyy",
          note: "לצורך חישוב גיל"
        },
        {
          label: "מין המטופל*",
          name: "gender",
          type: "select",
          rules: "required",
          options: [
            { value: "", text: "בחר מין" },
            { value: "male", text: "זכר" },
            { value: "female", text: "נקבה" }
          ]
        },
        {
          label: "נייד*",
          name: "phone",
          type: "input",
          inputType: "tel",
          rules: {
            required: true,
            regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
          },
          autocomplete: "off",
          note: "משמש כניסה לאזור אישי"
        },
        {
          label: "טלפון נוסף",
          name: "phone2",
          type: "input",
          inputType: "tel",
          rules: {
            regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
          },
          autocomplete: "off"
        },
        {
          label: "אימייל",
          name: "email",
          type: "input",
          inputType: "text",
          rules: {
            emailRegex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
          },
          autocomplete: "off"
        },
        {
          label: "שפה מועדפת",
          name: "lang",
          type: "select",
          options: [
            { value: "", text: "בחירה" },
            { value: "hebrew", text: "עברית" },
            { value: "english", text: "אנגלית" },
            { value: "russian", text: "רוסית" },
            { value: "arabic", text: "ערבית" }
          ]
        },
        {
          label: "שם אפוטרופוס",
          name: "parent_name",
          type: "input",
          inputType: "text",
          autocomplete: "off"
        },
        {
          label: "סטטוס משפחתי של ההורים*",
          name: "parental_status",
          type: "select",
          rules: "required",
          options: parentalStatus,
          customClass: "parental_status"
        }
      ]
    };
  },
  methods: {
    setTutorial,
    async intro() {
      await new Promise(resolve => setTimeout(resolve, 400));
      this.setTutorial(
        "parental_status",
        `רופא/ה יקר/ה,
נבקשך למלא את הסטטוס המשפחתי של ההורים שייבדק במעמד הקבלה וזאת לשם קבלת ההסכמה כדין בעבור קטינים,
תודה.`
      );
    }
  }
};
</script>
